import React from "react";

const WhiteCard = ({ children, classNames = "" }) => <div className={`${classNames} white-card`}>{children}</div>;

export default WhiteCard;
